export default [
  {
    header: 'ระบบร้องทุกข์',
    menu: 'Complain',
  },
  {
    title: 'ค้นหา',
    route: 'ComplaintMainSearch',
    icon: 'MailIcon',
    menu: 'Search',
  },
  {
    title: 'ภาพรวมสถิติ Fasttrack',
    route: 'DashboardStatisticsFasttrackRole',
    icon: 'CircleIcon',
    menu: 'DashboardStatisticsFasttrackRole',
  },
  {
    title: 'ศูนย์รับเรื่องราวร้องทุกข์',
    icon: 'FileTextIcon',
    menu: 'Complaint',
    children: [
      {
        title: 'รับเรื่องร้องทุกข์',
        route: 'servicecentercomplaint',
        icon: 'CircleIcon',
      },
      {
        title: 'ประวัติการรับเรื่อง',
        route: 'ReceivedHistory',
        icon: 'CircleIcon',
      },
    ],
  },
  {
    title: 'ระบบให้คำปรึกษา',
    route: 'Consult',
    icon: 'ShieldIcon',
    menu: 'Consult',
  },
  {
    title: 'ศูนย์คัดกรอง',
    icon: 'CircleIcon',
    menu: 'Screening',
    children: [
      {
        title: 'คัดกรองเรื่องร้องทุกข์',
        route: 'screening',
        icon: 'CircleIcon',
      },
      {
        title: 'GCC 1111',
        route: 'GCC',
        icon: 'CircleIcon',
      },
      {
        title: 'รายการส่งเรื่องร้องทุกข์',
        route: 'ComplaintScreeningSendSummary',
        icon: 'CircleIcon',
      },
      {
        title: 'รายการรับเรื่องร้องทุกข์',
        route: 'ComplaintScreeningReceivedSummary',
        icon: 'CircleIcon',
      },
    ],
  },
  {
    title: 'ธุรการกอง',
    icon: 'CircleIcon',
    menu: 'Deptlist',
    children: [
      {
        title: 'ตรวจสอบรายการ',
        route: 'Deptlist',
        icon: 'FileTextIcon',
      },
    ],
  },
  {
    title: 'หัวหน้าทีม',
    icon: 'CircleIcon',
    menu: 'LeaderDept',
    children: [
      {
        title: 'ตรวจสอบรายการ',
        route: 'LeaderDept',
        icon: 'FileTextIcon',
      },
    ],
  },
  {
    title: 'เจ้าหน้าที่',
    icon: 'CircleIcon',
    menu: 'Officer',
    children: [
      {
        title: 'จัดการเรื่องราวร้องทุกข์',
        route: 'Officer',
        icon: 'FileTextIcon',
      },
      // {
      //   title: 'ดำเนินการเรื่องร้องทุกข์แบบกลุ่ม',
      //   route: null,
      //   icon: 'CircleIcon',
      // },
    ],
  },
  {
    title: 'เจ้าหน้าที่ภูมิภาค',
    icon: 'CircleIcon',
    menu: 'ProvincialComplaint',
    children: [
      {
        title: 'รับเรื่องราวร้องทุกข์',
        route: 'ProvincialComplaint',
        icon: 'FileTextIcon',
      },
      {
        title: 'ดำเนินการเรื่องร้องทุกข์แบบกลุ่ม',
        route: 'ProvincialOfficer',
        icon: 'CircleIcon',
      },
    ],
  },
  {
    title: 'เจ้าหน้าที่ กทม',
    icon: 'CircleIcon',
    menu: 'BangkokComplaint',
    children: [
      {
        title: 'ดำเนินการเรื่องร้องทุกข์',
        route: 'BangkokOfficer',
        icon: 'CircleIcon',
      },
    ],
  },
  {
    title: 'Dashboard กทม.',
    route: 'dashboard-bangkok',
    icon: 'CircleIcon',
    menu: 'dashboard-bangkok',
  },
  {
    title: 'แนบเอกสารเพิ่มเติม',
    route: 'attachment',
    icon: 'CircleIcon',
    menu: 'ComplaintAttachment',
  },
  {
    title: 'แก้ไขรายชื่อผู้ดูแลข้อมูล',
    route: 'Transfer',
    icon: 'CircleIcon',
    menu: 'Transfer',
  },
  {
    title: 'รายการรับ - ส่งเรื่องร้องทุกข์',
    icon: 'CircleIcon', 
    menu: 'ComplaintSummary',   
    children: [
      {
        title: 'รายการส่งเรื่องร้องทุกข์',
        route: 'ComplaintSendSummary',
        icon: 'CircleIcon',
      },
      {
        title: 'รายการรับเรื่องร้องทุกข์',
        route: 'ComplaintReceivedSummary',
        icon: 'CircleIcon',
      },
      {
        title: 'รายการรับ-ส่งเรื่องร้องทุกข์รายบุคคล',
        route: 'ComplaintPersonalSummary',
        icon: 'CircleIcon',
      },
    ],
  },
  {
    title: 'ประวัติทั้งหมด',
    route: 'ComplaintHistory',
    icon: 'CircleIcon',
    menu: 'History',
  },
  {
    title: 'มติ คคบ.',
    route: 'Conclusion',
    icon: 'FileTextIcon',
    menu: 'Conclusion',
  },
  {
    title: 'ตั้งค่าลำดับการจ่ายงาน',
    route: 'AssignWorkOrder',
    icon: 'CircleIcon',
    menu: 'AssignWorkOrder',
  },
  {
    title: 'ไกล่เกลี่ย',
    icon: 'CircleIcon',
    menu: 'Mediate',
    children: [
      {
        title: 'จดหมายเชิญอนุกรรมการ',
        route: 'SubCommitteeInvitation',
        icon: 'CircleIcon',
      },
      {
        title: 'อนุมัติจดหมายเชิญอนุกรรมการ',
        route: 'SubCommitteeApprove',
        icon: 'CircleIcon',
      },
      {
        title: 'จัดการอนุกรรมการ',
        route: 'SubCommittee',
        icon: 'CircleIcon',
      },
      {
        title: 'จัดการกลุ่มอนุกรรมการ',
        route: 'SubCommitteeGroup',
        icon: 'CircleIcon',
      },
    ],
  },
]
